import { Link, NavLink } from "react-router-dom";
import { ShoppingBag, Menu, X } from "lucide-react";
import { useState } from "react";
import { useCart } from "../context/CartContext";

const links = [
    { to: "/", label: "Home" },
    { to: "/shop", label: "Shop" },
    { to: "/about", label: "About" },
    { to: "/contact", label: "Contact" },
];

const Header = () => {
    const { count, setOpen } = useCart();
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <header
            data-testid="site-header"
            className="sticky top-0 z-40 bg-[#FBF9F6]/85 backdrop-blur-xl border-b border-[#E5E0D8]/70"
        >
            <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-20 h-20 flex items-center justify-between">
                <Link
                    to="/"
                    data-testid="header-logo-link"
                    className="font-serif-display text-2xl md:text-3xl text-[#0A2342] leading-none"
                    onClick={() => setMenuOpen(false)}
                >
                    Crown &amp; Oak
                </Link>

                <nav className="hidden md:flex items-center gap-10">
                    {links.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            end={l.to === "/"}
                            data-testid={`nav-link-${l.label.toLowerCase()}`}
                            className={({ isActive }) =>
                                `text-[11px] tracking-[0.22em] uppercase font-medium transition-colors ${
                                    isActive
                                        ? "text-[#0A2342]"
                                        : "text-[#5C6A79] hover:text-[#0A2342]"
                                }`
                            }
                        >
                            {l.label}
                        </NavLink>
                    ))}
                </nav>

                <div className="flex items-center gap-3">
                    <button
                        data-testid="cart-toggle-btn"
                        onClick={() => setOpen(true)}
                        className="relative p-2 text-[#0A2342] hover:text-[#9E5A35] transition-colors"
                        aria-label="Open cart"
                    >
                        <ShoppingBag size={22} strokeWidth={1.5} />
                        {count > 0 && (
                            <span
                                data-testid="cart-badge-count"
                                className="absolute -top-0.5 -right-0.5 bg-[#9E5A35] text-white text-[10px] font-medium rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1"
                            >
                                {count}
                            </span>
                        )}
                    </button>
                    <button
                        data-testid="mobile-menu-toggle"
                        onClick={() => setMenuOpen((v) => !v)}
                        className="md:hidden p-2 text-[#0A2342]"
                        aria-label="Toggle menu"
                    >
                        {menuOpen ? <X size={22} /> : <Menu size={22} />}
                    </button>
                </div>
            </div>

            {menuOpen && (
                <div
                    data-testid="mobile-menu"
                    className="md:hidden border-t border-[#E5E0D8] bg-[#FBF9F6]"
                >
                    <div className="px-6 py-4 flex flex-col gap-4">
                        {links.map((l) => (
                            <NavLink
                                key={l.to}
                                to={l.to}
                                end={l.to === "/"}
                                onClick={() => setMenuOpen(false)}
                                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                                className="text-sm tracking-[0.22em] uppercase text-[#0A2342]"
                            >
                                {l.label}
                            </NavLink>
                        ))}
                    </div>
                </div>
            )}
        </header>
    );
};

export default Header;
